/*
 *******************************************************************************
 * 
 *  Filename:   ./config/routesAdminSettings.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Routes for Admin Settings Components
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Wednesday, January 30, 2019 - 11:59 PM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      01/30/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Loading...</div>;
}

export const AdminSettingList = Loadable({
    loader: () => import('../containers/AdminSettings/AdminSettingListContainer'),
    loading: Loading,
});

export const AdminSettingForm = Loadable({
    loader: () => import('../containers/AdminSettings/AdminSettingEditContainer'),
    loading: Loading,
});


// WEBPACK FOOTER //
// ./src/config/routesAdminSettings.js